(() => {
  const setOpen = (target, isOpen) => {
    if (!target) return;
    target.classList.toggle('is-open', isOpen);
    target.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.body.classList.toggle('chemistry-menu-open', isOpen);
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-chem-open]');
    const closer = event.target.closest('[data-chem-close]');

    if (opener) {
      const target = document.querySelector(opener.dataset.chemOpen);
      setOpen(target, true);
      return;
    }

    if (closer) {
      const target = closer.closest('.chem-drawer, .chem-search-panel');
      setOpen(target, false);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.chem-drawer.is-open, .chem-search-panel.is-open').forEach((element) => {
      setOpen(element, false);
    });
  });

  const revealElements = document.querySelectorAll('[data-chem-reveal]');
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    revealElements.forEach((element) => revealObserver.observe(element));
  } else {
    revealElements.forEach((element) => element.classList.add('is-visible'));
  }

  const headerShell = document.querySelector('[data-chem-header-shell]');
  if (headerShell && headerShell.dataset.sticky === 'true') {
    const headerOffset = headerShell.offsetTop + headerShell.offsetHeight;
    const updateStickyHeader = () => headerShell.classList.toggle('is-stuck', window.scrollY > headerOffset);
    updateStickyHeader();
    window.addEventListener('scroll', updateStickyHeader, { passive: true });
  }

  const footerDetails = document.querySelectorAll('.chem-footer__column details');
  const footerBreakpoint = window.matchMedia('(max-width: 749px)');
  const updateFooterDetails = () => {
    footerDetails.forEach((detail) => {
      detail.open = !footerBreakpoint.matches;
    });
  };
  updateFooterDetails();
  footerBreakpoint.addEventListener('change', updateFooterDetails);
})();
